/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataViewItemModal.tpl.html';

/**
 * Module for the metadata view item modal.
 */
angular
  .module('shared.metadataViewItemModal', [])
  /**
   * Metadata view item controller.  Controller for the metadataViewItemModal.tpl.html template.
   */
  .controller(
    'MetadataViewItemModalCtrl',
    function (
      $filter,
      $uibModalInstance,
      $rootScope,
      $scope,
      $timeout,
      $window,
      httpMetadata,
      ALERT_EVENTS,
      item,
      fileInfo,
      orgInfo
    ) {
      var MAX_DISPLAYED_LINES = 4000,
        dateFilter = $filter('date'),
        i18n = $filter('i18n');

      $scope.title = item.path;
      $scope.contentTitle = i18n('CONTENT_FROM_BACKUP', [dateFilter(item.date, 'MMM d, yyyy h:mm a')]);
      $scope.isBinary = !fileInfo.isText;
      $scope.isLarge = fileInfo.isText && fileInfo.lineCount > MAX_DISPLAYED_LINES;
      $scope.fileData = fileInfo.data;
      $scope.exportInProgress = false;
      $scope.showLoadingMask = false;

      /**
       * Function to export the file.
       */
      $scope.exportFile = function () {
        $scope.exportInProgress = true;

        httpMetadata.getItemExportUrl(orgInfo.sfId, item.path, item.batchIdStart).then(
          function (res) {
            $window.location.href = res ? res.url : '';
            $scope.exportInProgress = false;
          },
          function () {
            $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('EXPORT_METADATA_ERROR'));
            $scope.exportInProgress = false;
          }
        );
      };

      /**
       * Function to cancel out of the model.
       */
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    }
  );
